import React from 'react';
import { connect } from 'react-redux';
import { IntlProvider, injectIntl, FormattedDate, FormattedNumber } from 'react-intl';
import { Table, OverlayTrigger, Tooltip, Label } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import moment from 'moment';
import 'moment-timezone';
import {
  isEmpty as _isEmpty,
  round as _round,
  divide as _divide,
  isFinite as _isFinite,
  take as _take,
  orderBy as _orderBy,
  find as _find,
  some as _some,
  join as _join,
} from 'lodash';

import VklBusinessData from 'components/layout/vkl/VklBusinessData';

class VklBusinessList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shownIndex: null,
    };
  }

  handleClick = index => {
    this.setState(prevState => ({ shownIndex: index === prevState.shownIndex ? null : index }));
  };

  getStatusIcon = status => {
    switch (status) {
      case '100':
        return <i class="far fa-square" />;

      case '300':
        return <i class="fas fa-play" />;

      case '500':
        return <i class="fas fa-copy" />;

      case '700':
        return <i class="fas fa-times text-danger" />;

      case '900':
        return <i class="fas fa-check text-success" />;

      case '950':
        return <i class="fas fa-ban text-danger" />;
    }

    return null;
  };

  getCustomerTypeIcon = activity => {
    if (activity.customer_type === 'company' || !_isEmpty(activity.customer_company_name)) {
      return <i class="fas fa-building" />;
    }
    return <i class="fas fa-user" />;
  };

  getActivityStatusDescription = status => {
    const {
      intl: { messages },
    } = this.props;

    const mapping = {
      100: messages.sad.offer_made,
      300: messages.sad.in_progress,
      500: messages.sad.predecessor_offer,
      700: messages.sad.lost,
      900: messages.sad.ordered,
      950: messages.sad.canceled,
    };

    if (mapping.hasOwnProperty(status)) {
      return mapping[status];
    }

    return null;
  };

  getRabatt = activity => {
    if (activity.sales_price && activity.list_price && activity.sales_price !== activity.list_price) {
      const perc = 1 - _round(_divide(activity.sales_price, activity.list_price), 2);
      if (_isFinite(perc)) {
        return (
          <span>
            <FormattedNumber value={perc} style="percent" /> /{' '}
          </span>
        );
      }
    }

    return null;
  };

  getLastComments = activity => {
    const comments = _take(_orderBy(activity.comments, 'cdate', 'desc'), 3);
    return comments.map((c, i) => {
      return <div key={i}>{c.content.length > 30 ? c.content.substr(0, 27) + ' ...' : c.content}</div>;
    });
  };

  getSortClass = key => {
    const { sortKey, sortOrder } = this.props;
    return sortKey !== key ? 'sorting' : 'sorting_' + (sortOrder === 'asc' ? 'asc' : 'desc');
  };

  sortList = key => {
    const { onSort } = this.props;

    if (onSort) {
      onSort(key);
    }
  };

  getWinLeasBadge = activity => {
    const approvedItem = _find(activity.winleases, w => {
      return !_isEmpty(w.application_approval_date);
    });
    const rejectedItem = _find(activity.winleases, w => {
      return !_isEmpty(w.application_rejection_date);
    });

    if (!_isEmpty(approvedItem)) {
      const type = approvedItem.offer_type === 1 ? 'F' : 'L';
      return (
        <Label bsStyle="danger" class="">
          {type} <i class="fas fa-check" />
        </Label>
      );
    }

    if (!_isEmpty(rejectedItem)) {
      const type = rejectedItem.offer_type === 1 ? 'F' : 'L';
      return (
        <Label bsStyle="danger" class="">
          {type} <i class="fas fa-times" />
        </Label>
      );
    }

    const hasFinancing = _some(activity.winleases, { offer_type: 1 });
    const hasLeasing = _some(activity.winleases, { offer_type: 0 });

    const stringArr = [];
    if (hasFinancing) stringArr.push('F');
    if (hasLeasing) stringArr.push('L');

    return (
      <Label bsStyle="danger" class="">
        {_join(stringArr, ' / ')}
      </Label>
    );
  };

  render() {
    const {
      intl: { messages },
      intl,
      projectConfig,
      activityList,
      user,
    } = this.props;
    const { shownIndex } = this.state;

    let tBody = [];
    // if (!vklBusinesses.pending && vklBusinesses.data
    if (activityList.length) {
      tBody = activityList.map((activity, i) => {
        return (
          <tr
            key={i}
            class={(i === shownIndex ? 'shown ' : '') + (i % 2 ? 'even ' : 'odd ')}
            onClick={() => {
              this.handleClick(i);
            }}
          >
            <td>
              {this.getCustomerTypeIcon(activity)}{' '}
              {_isEmpty(activity.customer_company_name)
                ? _join([activity.customer_lastname, activity.customer_firstname], ', ')
                : activity.customer_company_name}
            </td>
            <td>{activity.sales_description || activity.sales_description_short}</td>
            <td class="text-right">
              {this.getRabatt(activity)}{' '}
              {activity.sales_price ? (
                <FormattedNumber value={activity.sales_price} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
            <td>
              {_isEmpty(activity.reference_date) ? (
                '-'
              ) : (
                <FormattedDate value={new Date(moment.tz(activity.reference_date, 'UTC').tz(user.profile.timezone))} />
              )}
            </td>
            <td>
              {_isEmpty(activity.last_modified_date) ? (
                '-'
              ) : (
                <FormattedDate
                  value={new Date(moment.tz(activity.last_modified_date, 'UTC').tz(user.profile.timezone))}
                />
              )}
            </td>
            <td>
              {_isEmpty(activity.last_pre_contract_date) ? (
                '-'
              ) : (
                <FormattedDate
                  value={new Date(moment.tz(activity.last_pre_contract_date, 'UTC').tz(user.profile.timezone))}
                />
              )}
              {activity.car_count > 1 ? ` (${activity.car_count}x)` : ''}
            </td>
            <td>{activity.comments.length > 0 ? this.getLastComments(activity) : '-'}</td>
            <td>
              {activity.salesman_lastname}, {activity.salesman_firstname}
            </td>
            <OverlayTrigger placement="top" overlay={<Tooltip>{messages.sad.winleas_data_available}</Tooltip>}>
              <td className="cursor-help">{activity.winleases.length > 0 ? this.getWinLeasBadge(activity) : ''}</td>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip>
                  <IntlProvider locale={intl.locale} messages={intl.messages}>
                    {this.getActivityStatusDescription(activity.status)}
                  </IntlProvider>
                </Tooltip>
              }
            >
              <td className="cursor-help">{this.getStatusIcon(activity.status)}</td>
            </OverlayTrigger>
          </tr>
        );
      });
    }

    if (shownIndex !== null) {
      // user wants to see details of a business
      tBody.splice(
        shownIndex + 1,
        0,
        <VklBusinessData data={activityList[shownIndex]} colSpan={10} key="activityDetails" />
      );
    }

    return (
      <Table responsive hover condensed class="table-detailed dataTable">
        <thead>
          <tr>
            <th>{messages.client}</th>
            <th>{messages.model}</th>
            <th
              style={{ width: '175px' }}
              onClick={() => this.sortList('salesPrice')}
              class={'text-right cursor ' + this.getSortClass('salesPrice')}
            >
              {messages.sad.sales_price}
            </th>
            <th
              style={{ width: '125px' }}
              onClick={() => this.sortList('referenceDate')}
              class={'cursor ' + this.getSortClass('referenceDate')}
            >
              {messages.sad.offer}
            </th>
            <th
              style={{ width: '140px' }}
              onClick={() => this.sortList('lastModifiedDate')}
              class={'cursor ' + this.getSortClass('lastModifiedDate')}
            >
              {messages.sad.modification}
            </th>
            <th
              style={{ width: '150px' }}
              onClick={() => this.sortList('lastPreContractDate')}
              class={'cursor ' + this.getSortClass('lastPreContractDate')}
            >
              {messages.sad.order}
            </th>
            <th>{messages.sad.notes}</th>
            <th>{messages.sad.salesman}</th>
            <th style={{ width: '65px' }} />
            <th style={{ width: '20px' }} />
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    projectConfig: state.data.projectConfig,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(VklBusinessList));
